import { render, staticRenderFns } from "./ModuleDescription.vue?vue&type=template&id=e75b9d28"
import script from "./ModuleDescription.vue?vue&type=script&lang=js"
export * from "./ModuleDescription.vue?vue&type=script&lang=js"
import style0 from "./ModuleDescription.vue?vue&type=style&index=0&id=e75b9d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports